export enum WebformEnum {
  CONTACT_MANAGER = 'contacta_a_tu_gestor',
  REQUEST_CHANGE_GENERAL_DATA = 'solicitud_cambio_datos_generales',
  REQUEST_CHANGE_ADDRESS = 'cambio_direccion',
  FEEDBACK = 'ecoembes_te_escucha',
  DUPLICATE_COORDINATED_CARD = 'duplicado_tarjeta_coordenadas',
  CANCELLATION = 'baja_ecoembes',
  SOCIETY_CHANGE = 'cambio_societario',
  UP_TO_DATE_WITH_OBLIGATIONS = 'al_corriente_con_obligaciones',
  ADHESION_TO_BUSINESS_PLANS = 'adhesion_a_planes_empresariales',
  COMPLAINTS = 'reclamaciones',
  BANK_DATA = 'datos_bancarios',
  AUDIT_REPORT = 'informe_de_auditoria',
  CREATION_GENERIC_TASK = 'creacion_tareas_generica',
  SIRAP_CONSTITUTION = 'constitucion_de_un_sirap',
  PRODUCER_REGISTRY_SUPPORT = 'asistencia_reporte_registro_prod',
  DECLARATION_SUPPORT_BASIC = 'apoyo_declaracion_envases_basico',
  DECLARATION_SUPPORT_ADVANCED = 'apoyo_declaracion_envases_avanza',
  CIRCULAR_CHECK = 'pack_cd',
  PACKAGING_MANAGEMENT_ADHESION = 'adhesion_gestion_de_envases',
  PAYMENT_FLEXIBILITY = 'flexibilizacion_pagos',
}
